<template>
  <div class="echarts">
    <div id="chart1" ref="chart1"></div>
  </div>
</template>

<script>
import Highcharts from 'highcharts'
export default {
  name: 'salecount',
  props: ['range', 'result'],
  data () {
    return {
      options: null,
      chart: null
    }
  },
  watch: {
    result () {
      this.chart.update({
        subtitle: { text: `${this.range.start} ~ ${this.range.end}` },
        xAxis: {
          categories: this.result.map(e => this.moment(e._id).format('MM/DD'))
        },
        plotOptions: {
          series: {
            colors: Array.from(this.result.map(e => this.moment(e._id).weekday()).map(e => (e === 0 || e === 6) ? '#E37878' : '#CCA16E'))
          }
        },
        series: [{
          data: this.result.map(e => {
            const wk = this.moment(e._id).weekday()
            return {
              y: e.total,
              color: (wk === 0 || wk === 6) ? '#E37878' : '#CCA16E'
            }
          })
        }]
      })
    }
  },
  mounted () {
    // const colors = Array.from(this.result.map(e => this.moment(e._id).weekday()).map(e => (e === 0 || e === 6) ? '#E37878' : '#CCA16E'))
    this.chart = Highcharts.chart(this.$refs.chart1, {
      chart: {
        type: 'column',
        layout: 'horizontal',
        verticalAlign: 'top',
        padding: 0,
        spacing: [5, 10, 0, 0],
        marginLeft: 50,
        // backgroundColor: 'var(--color-infobox)',
        backgroundColor: '#FFFFFF',
        plotBackgroundColor: '#FFFFFF',
        height: 386
      },
      title: {
        text: '營收統計圖表',
        style: {
          letterSpacing: '3px',
          fontSize: '18px',
          fontWeight: 'bold',
          textAlign: 'right',
          color: '#292929',
          padding: '8px'
        }
      },
      subtitle: {
        text: `${this.range.start} ~ ${this.range.end}`,
        style: {
          fontSize: '14px',
          fontWeight: '500',
          textAlign: 'right',
          color: '#292929',
          padding: '4px'
        }
      },
      credits: {
        enabled: false
      },
      xAxis: {
        categories: this.result.map(e => this.moment(e._id).format('MM/DD'))
      },
      legend: {
        enabled: false
      },
      yAxis: {
        labels: {
          // align: 'left',
          x: -10
        },
        title: {
          text: '營收',
          margin: 20,
          style: {
            fontSize: '10px',
            letterSpacing: '1px',
            fontWeight: '400',
            textAlign: 'right',
            color: '#292929',
            padding: 5
          }
        }
      },
      series: [{
        name: '營收',
        data: this.result.map(e => {
          const wk = this.moment(e._id).weekday()
          return {
            y: e.total,
            color: (wk === 0 || wk === 6) ? '#E37878' : '#CCA16E'
          }
        })
      }]
    })
    // console.log(colors)
  }
}
</script>

<style scoped>
#chart1 {
  /* background-color: #E5E5E5; */
  width: 100%;
  height: 386px;
  border-radius: 5px;
  border: 2px solid var(--color-border);
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  background-color: var(--color-infobox);
  border-radius: 20px;
}
.echarts {
  width: 556px;
  height: 386px;
  padding-block: 5px;
}
</style>
